module.exports = __webpack_public_path__ + "static/img/32.fa3e164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/32.png
// module id = sQv3
// module chunks = 1